import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../components/spinner";

const CatalogoSolicitudOrdenComprasAprob = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const txtBuscador = useRef();

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "RAZÓN SOCIAL", textAlign: "left" },
    { label: "CONCEPTO", textAlign: "left" },
    { label: "FECHA DE SOLICITUD", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              props.tipo === 1
                ? x.idordenservicio
                : x.idordencompra?.includes(target.value) ||
                  x.razonsocial
                    .toLowerCase()
                    .includes(target.value.toLowerCase()) ||
                  x.concepto
                    .toLowerCase()
                    .includes(target.value.toLowerCase()) ||
                  moment
                    .utc(x.fecha)
                    .format("DD/MM/YYYY")
                    .includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarOrdenesCompras = () => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/solicitudesdecomprascata?idefiscal=${idefiscal}&tipoc=${props.tipo}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data.length > 0) {
          setActivate(false);
          var data = [];
          for (let i = 0; i < response.data.length; i++) {
            data.push({
              idproveedor: response.data[i].idproveedor,
              idcordinacion: response.data[i].idcordinacion,
              razonsocial: response.data[i].razonsocial,
              concepto: response.data[i].concepto,
              idordencompra: response.data[i].idordencompra,
              fecha: response.data[i].fecha,
              observaciones: response.data[i].observaciones,
              monto: response.data[i].monto,
              montoiva: response.data[i].montoiva,
              fechacrea: response.data[i].fecha_crea,
              tipo: response.data[i].tipo,
              idordenservicio: response.data[i].idordenservicio,
            });
          }
          setRecords(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const selectSolicitud = () => {
    var idcordinacion = values[0].idcordinacion;
    var razonsocial = values[0].razonsocial;
    var concepto = values[0].concepto;
    var idproveedor = values[0].idproveedor;
    var idordencompra = values[0].idordencompra;
    var fecha = values[0].fecha;
    var observaciones = values[0].observaciones;
    var monto = values[0].monto;
    var montoiva = values[0].montoiva;
    var fechacrea = values[0].fechacrea;
    var tipo = values[0].tipo;
    var idordenservicio = values[0].idordenservicio;

    blanquear();
    props.onHideAceptarSolicitud(
      idcordinacion,
      razonsocial,
      concepto,
      idproveedor,
      idordencompra,
      fecha,
      observaciones,
      monto,
      montoiva,
      fechacrea,
      tipo,
      idordenservicio,
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var idcordinacion = recordsAfterPagingAndSorting()[index].idcordinacion;
    var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
    var concepto = recordsAfterPagingAndSorting()[index].concepto;
    var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
    var idordencompra = recordsAfterPagingAndSorting()[index].idordencompra;
    var fecha = recordsAfterPagingAndSorting()[index].fecha;
    var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
    var monto = recordsAfterPagingAndSorting()[index].monto;
    var montoiva = recordsAfterPagingAndSorting()[index].montoiva;
    var fechacrea = recordsAfterPagingAndSorting()[index].fechacrea;
    var tipo = recordsAfterPagingAndSorting()[index].tipo;
    var idordenservicio = recordsAfterPagingAndSorting()[index].idordenservicio;

    var datos = [];
    datos.push({
      idcordinacion,
      razonsocial,
      concepto,
      idproveedor,
      idordencompra,
      fecha,
      observaciones,
      monto,
      montoiva,
      fechacrea,
      tipo,
      idordenservicio,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarOrdenesCompras();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Ordenes de Compra/Servicios</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              ref={txtBuscador}
              placeholder="Buscar Orden de Compra/Servicio..."
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "10px" }}>
                      {props.tipo === '1'
                        ? item.idordenservicio
                        : item.idordencompra}
                    </td>
                    <td className="py-2 " style={{ width: "auto" }}>
                      {item.razonsocial}
                    </td>
                    <td className="py-2 " style={{ width: "auto" }}>
                      {item.concepto}
                    </td>
                    <td className="py-2 text-center" style={{ width: "150px" }}>
                      {moment.utc(item.fecha).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={selectSolicitud}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoSolicitudOrdenComprasAprob;
